import styled from 'styled-components';
import {Column, Row} from '../../common/Layouts/Layouts';
import {ISrpHotelCardPersuasionTypes} from '../../../../../shared/pages/SRP/redux/types';

function getHiddenDropDownWrapperDivPositioning(direction) {
  switch (direction) {
    case 'top':
      return 'bottom: 1.5rem; left: 0;';
    case 'bottom-right':
      return 'top: 1.5rem; left: 0;';

    default:
      // 'bottom'
      return 'top: 2rem; right: 0;';
  }
}

function getTipUIPositioning(direction) {
  switch (direction) {
    case 'top':
      return 'bottom: -0.2rem; left: 15%;';
    case 'bottom-right':
      return 'top: -0.2rem; left: 10%;';

    default:
      // 'bottom'
      return 'top: -0.2rem; right: 15%;';
  }
}

function getTipUIPointerDirection(direction) {
  switch (direction) {
    case 'top':
      return 'transform: translate(-50%, -50%) rotate(45deg);';

    default:
      // 'bottom'
      return 'transform: translate(-50%, 50%) rotate(45deg);';
  }
}

// HOVER STUFF

export const PersuasionHoverTitleSpan = styled.span`
  font-size: ${props => (props.type === 'belowPricePersuasion' ? '1rem' : '')};
`;

export const HiddenDropdownWrapperDiv = styled.div`
  width: ${props => props.width || '22rem'};
  ${props => getHiddenDropDownWrapperDivPositioning(props.direction)}
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  right: ${props => props.right};
  left: ${props => props.left};
  max-width: ${props => props.width || '30rem'};
  padding: ${props => props.theme.spacing.base} 0;
  z-index: ${props => props.theme.misc.zIndex.xsmall};
  visibility: hidden;
  transition: opacity 0.8s;
  position: absolute;
`;

export const HoverTargetWrapperDiv = styled.span(
  props => `
  position: relative;
  text-align: left;
  display: inline-flex;
  margin-right: ${
    [
      'contentPersuasion2',
      'belowBannerPersuasion',
      'abovePricePersausion',
      'belowPricePersuasion',
    ].indexOf(props.type) > -1
      ? ''
      : props.theme.spacing.custom(8)
  };
  margin-top: ${props.hasMultiple && !props.isContentPersuasion2 ? props.theme.spacing.small : ''};
  &:hover > ${HiddenDropdownWrapperDiv} {
    visibility: visible;
  }
  ${props.wrapperStyles}
`,
);

export const TopDiv = styled.div(
  props => `
background-color: ${props.theme.colors.goWhite.base};
border-radius: ${props.theme.misc.borderRadius.base};
box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)} ${
    props.theme.colors.shadow.base
  };
`,
);

const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
  }
`;

export const TipPositioning = styled(TipUI)`
  ${props => getTipUIPositioning(props.direction)}
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  left: ${props => props.left};
  right: ${props => props.right};
  &::after {
    ${props => getTipUIPointerDirection(props.direction)}
    transform: ${props => props.transform};
    background: ${props => props.bgColor};
    box-shadow: 0 ${props => props.theme.spacing.xxsmall} ${props => props.theme.spacing.custom(4)}
      ${props => props.theme.colors.shadow.base};
  }
`;

// CONTENT STUFF

export const ListDropDownWrapper = styled.div(
  props => `
width: 100%;
display: flex;
list-style-type: none;
overflow: hidden;
padding: ${props.theme.spacing.small} 0 0;
flex-direction: column;
> li {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding: ${props.theme.spacing.base};
  position: relative;
  &:last-child {
    border-bottom: none;
  }
}
`,
);

export const TextBlockDropDownWrapper = styled(Column)`
  padding: ${props => props.theme.spacing.base};
  color: ${props => props.color};
  background-color: ${props => props.bgColor};
`;

export const RoundBoxWrap = styled.div(
  props => `
  width: 1.5rem;
  height: 1.5rem;

`,
);

export const TextBlockDDHeading = styled(Row)`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  padding: ${props => props.theme.spacing.custom(3)} ${props => props.theme.spacing.base}
    ${props => props.theme.spacing.custom(3)} ${props => props.theme.spacing.small};
  margin-bottom: ${props => props.theme.spacing.small};
  background: ${props => props.bgColor};
  color: ${props => props.color};
  border-radius: 2.5rem;
`;

export const TextBlockDDHeadingSpan = styled.span`
  color: ${props => props.color};
  background-color: ${props => props.bgColor};
  /* color: ${props => props.color || props.theme.colors.goGreen.base}; */
  padding: 0 0 0 ${props => props.theme.spacing.small};
  text-transform: capitalize;
`;

export const TextBlockDDFilterText = styled.p`
  line-height: 1.3;
  font-size: ${props => props.theme.font.custom(14)};
  padding-top: ${props => props.theme.spacing.base};
`;

export const BlueLinkText = styled.span`
  margin-top: ${props => props.theme.spacing.base};
  color: ${props => props.theme.colors.goBrandBlue.base};
  cursor: pointer;
`;

// CONTENT STUFF

export const WrapperDiv = styled.span`
  display: flex;
  align-items: center;
`;

function getPaddingMainTextTag(type: ISrpHotelCardPersuasionTypes, hasBgColor) {
  switch (type) {
    case 'customLocation':
    case 'contentPersuasion1':
    case 'contentPersuasion2':
    case 'aboveRatePlanPersuasion':
      return `0.3rem ${hasBgColor ? '0.8rem' : '0'} 0.3rem ${hasBgColor ? '0.8rem' : '0'}`;
    case 'belowPricePersuasion':
      return `0.3rem 0 0.3rem 0`;

    default:
      return '0.3rem 0.8rem 0.3rem 0.8rem';
  }
}

export const TextWrapperSpan = styled.div`
  /* ${props => (props.hasPersuasionTitlePadding ? 'padding: 0.4rem 0.7rem 0.4rem 0.7rem;' : '')} */
  border-radius: ${props =>
    props.type !== 'contentPersuasion2' ? props.theme.misc.borderRadius.custom(15) : ''};
  /* font-weight: ${props => (props.type == 'contentPersuasion2' ? 'bold' : '')}; */
  font-size: ${props => (props.type == 'contentPersuasion2' ? props.theme.font.base : '')};
  border-radius: ${props =>
    props.type == 'contentPersuasion2' ? props.theme.misc.borderRadius.custom(2) : ''};
  ${props => (props.hasHover ? 'cursor: pointer;' : '')}

  color: ${props => props.color};
  background-color: ${props => props.bgColor};
  ${props => (props.isGradient ? `background-image: ${props.bgColor};` : '')}
  /* margin: ${props => (props.margin ? props.margin : 'auto')}; */
  text-transform: capitalize;
  padding: ${props => getPaddingMainTextTag(props.type, props.hasBgColor)};
  border: ${props =>
    props.showLabelTextBorder ? `1px solid ${props.color}` : props.border ? props.border : 'none'};
  display: flex;
  align-items: center;
  span {
    max-width: ${props =>
      props.type === 'aboveRatePlanPersuasion' && !props.hasSingleItem ? '16rem' : '30rem'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const IconWrapperDiv = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.small};
  /* flex-wrap: wrap; */
  flex-direction: row;
  align-items: center;
`;

export const TextWrapper = styled.p(
  props => `
  padding-left: ${props.theme.spacing.custom(8)};
  color: ${props.theme.colors.downriver.dark};
  line-height: 1.3;
`,
);

export const MiniIconWrapperSpan = styled.span`
  margin-right: ${props => props.theme.spacing.small};
`;

export const MainTextIconWrapperSpan = styled.span`
  display: flex;
  align-items: center;
  margin-right: ${props => (props.type === 'belowPricePersuasion' ? '0.5rem' : '0.8rem')};
`;

export const TextLabelIconContainer = styled.span(
  props => `
  // margin: -3px 0 0 0;
  padding: 0 ${props.theme.spacing.small} 0 0;
`,
);
